// Inline style tokens for The Board (matches /try). Fonts are loaded in __root.tsx.
export const GOLD = "#B8956A";
export const INK = "#F0EDE8";
export const MUTED = "rgba(240,237,232,0.62)";
export const LINE = "rgba(255,255,255,0.08)";
export const PANEL = "rgba(255,255,255,0.02)";
export const BG = "#080808";
export const mono = "'JetBrains Mono', ui-monospace, monospace";
export const display = "'Antonio', 'Sora', system-ui, sans-serif";
export const sans = "'Sora', system-ui, sans-serif";
export const serif = "Georgia, serif";
export const OK = "#7FC08A";     // mic live
export const WARN = "#e6c27a";   // blocked / dropped
export const FILE_PAPER = "#d7c6a1";
export const FILE_INK = "#17140f";
export const FILE_MUTED = "#594d3c";
export const FILE_RULE = "rgba(91,66,35,.34)";
